import useHomepageSiteNavigationElementSchemaQuery from '../../hooks/useHomepageSiteNavigationElementSchemaQuery';

const SiteNavigationElementSchema = () => {
  const data = useHomepageSiteNavigationElementSchemaQuery();

  const homepageSiteNavigationElementSchema = data?.wp?.sitewideSettings?.optionsSitewideSettings?.homepageSiteNavigationElementSchema;

  if (homepageSiteNavigationElementSchema) {
    return (
      <div
        dangerouslySetInnerHTML={{ __html: homepageSiteNavigationElementSchema }}
        style={{ display: 'none' }}
      />
    );
  }

  return null;
};

export default SiteNavigationElementSchema;
